// Brand color — kept as a hex literal because it is alpha-concatenated (`${PRIMARY_COLOR}08`),
// and `var(--color-primary)08` is invalid CSS. Mirrors --color-primary.
export const PRIMARY_COLOR = '#772cbb';

interface StatusEntry {
  label: string;
  color: string;
  bg: string;
  icon: string;
}

interface SourceEntry {
  label: string;
  icon: string;
}

// Status configuration \u2014 country-agnostic. Four canonical statuses match the
// bookings_status_check constraint AND production data after the active \u2192
// confirmed backfill. Legacy aliases stay mapped so any pre-backfill row
// (or other-country drift) still renders correctly.
export const STATUS_CONFIG: Record<string, StatusEntry> = {
  pending: { label: 'Pending', color: 'var(--color-warning)', bg: 'var(--color-warning-bg)', icon: '\u23F3' },
  confirmed: { label: 'Confirmed', color: 'var(--color-info)', bg: 'var(--color-info-bg)', icon: '\u2705' },
  completed: { label: 'Completed', color: 'var(--color-success)', bg: 'var(--color-success-bg)', icon: '\uD83C\uDF89' },
  cancelled: { label: 'Cancelled', color: 'var(--color-error)', bg: 'var(--color-error-bg)', icon: '\u274C' },
  // Legacy aliases \u2014 map to the canonical four for display only.
  active: { label: 'Confirmed', color: 'var(--color-info)', bg: 'var(--color-info-bg)', icon: '\u2705' },
  approved: { label: 'Confirmed', color: 'var(--color-info)', bg: 'var(--color-info-bg)', icon: '\u2705' },
  canceled: { label: 'Cancelled', color: 'var(--color-error)', bg: 'var(--color-error-bg)', icon: '\u274C' }
};

// Block styling - DISTINCT from cancelled (orange/amber instead of red)
export const BLOCK_STYLE: { color: string; bg: string; border: string } = {
  color: 'var(--color-warning-text)',      // Orange-700
  bg: 'var(--color-warning-bg)',         // Orange-50
  border: 'var(--color-warning)'      // Orange-600
};

// Source configuration
export const SOURCE_CONFIG: Record<string, SourceEntry> = {
  website: { label: 'Website', icon: '\uD83C\uDF10' },
  phone: { label: 'Phone', icon: '\uD83D\uDCDE' },
  'walk-in': { label: 'Walk-in', icon: '\uD83D\uDEB6' },
  referral: { label: 'Referral', icon: '\uD83D\uDC65' },
  portal: { label: 'Portal', icon: '\uD83D\uDDA5\uFE0F' }
};

// Calendar constants for time-based positioning
export const CALENDAR_START_HOUR = 8;
export const CALENDAR_END_HOUR = 19;
export const TOTAL_CALENDAR_HOURS = CALENDAR_END_HOUR - CALENDAR_START_HOUR;

// Day name mapping for availability patterns
export const DAY_NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;
